import React, { FC } from "react";
import { Meter } from "../../../interfaces/Meter";
import DataTable from 'react-data-table-component';


interface MeterDataRow {
  uuid: string;
  meter: Meter;
  value: number;
  units: string;
  timestamp: string;
}

interface IProps {
    data: MeterDataRow[]| null | [];
};


const InternalMeterDataTable:FC<IProps> = (props) => {

    const columns = [
    {
        name:'Timestamp',
        selector: (row: MeterDataRow) => new Date(row.timestamp).toLocaleString(),
        sortable: true,
    },
    {
        name:'Value',
        selector: (row: MeterDataRow) => row.value,
        sortable: false,
    },
    {
        name:'Units',
        selector: (row: MeterDataRow) => row.units,
        sortable: false,
    },

    ]

    const title = 'Data';

    return <DataTable
              title={title}
              columns={columns}
              data={props.data || []}
              pagination
              paginationPerPage={25}
              paginationRowsPerPageOptions={[25, 50, 100, 200]}
              theme='dark'
    
            />
};

export default InternalMeterDataTable;